<template>
     <div>
             <div style="width:1300px;margin:0 auto" id="v-content" :style="{minHeight:Height+'px'}">
                 <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
                      <p class="mt-2 mb-0">
                        <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                            采购计划
                        </span>
                        <span class="ml-5">
                              <span>查询时间从
                                              <span class="yanse" style="font-size:15px;">
                                                      {{searchForm.DateLessThan | changeDate}}
                                                </span>
                                                      到
                                                <span class="yanse" style="font-size:15px;">
                                                        {{searchForm.DateMoreThan | changeDate1}}
                                                </span>
                              </span>
                        </span>
                        <span class="float-right span_close mr-1" style="display:block;width:20px;li   ne-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                        </span>
                      </p>
                      <p class="mb-0 mt-2" style="font-weight:600;color:red;">
                         (单击表头显示列表信息)
                      </p>

                    <div class="row ml-2 mt-2 mb-2">
                               <div class="col-lg-6">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">

                                <div class="col-lg-6">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        供应商编号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.supplierNum"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <div class="col-lg-6">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.drugNameOrCode"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                 </div>
                             </div>
                          </div>
                       </div>
                        <div class="col-lg-6">
                                <div class="row">
                                        <div class="col-lg-7">
                            <div class="row">
                                <div class="col-lg-6">
                                   <div class="row">
                                      <div class="col-lg-6 P-0">
                                          <div class="row ml-lg-1 p-0 font">
                                              查询日期:
                                          </div>
                                      </div>
                                      <div class="col-lg-6 p-0">
                                              <date3 @changeDate="changeDate1($event)"/>
                                      </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                             到:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                          <date class="picker2"  @changeDate="changeDate2($event)"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                       </div>
                       <div class="col-lg-5">
                           <div class="row ml-lg-2 ">
                                 <button class="btn-primary font_btn ml-lg-2 w-25 button_zi" @click="getSupplierOrder()">查询</button>
                           </div>
                       </div>
                      </div>
                  </div>
                </div>
                     <div v-if="showPage">
                            <table class="table table-striped table-hover sett">
                                <thead>
                                   <tr style="white-space: nowrap;" @click="changeWidth($event)">
                                                  <th class="autocut">订单号</th>
                                                  <th class="autocut">供应商</th>
                                                  <th class="autocut">数量</th>
                                                  <th class="autocut">进价</th>
                                                  <th class="autocut">批量价</th>
                                                  <th class="autocut">创建时间</th>
                                                  <th class="autocut">品种编号</th>
                                                  <th class="autocut">品名</th>
                                                  <th class="autocut">产地</th>
                                                  <th class="autocut">包装</th>
                                                  <th class="autocut">剂型或类型</th>
                                                  <th class="autocut">单位</th>
                                                  <th class="autocut">批准文号</th>
                                                  <th class="autocut">状态</th>
                                                  <th style="width:100px;text-align:center;">上传图片</th>
                                             </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in tableData" :key="index">
                                                 <td class="text-center sett-td">{{item.num}}</td>
                                                  <td class="text-center sett-td">{{item.supplierName}}</td>
                                                  <td class="text-center sett-td">{{item.counts}}</td>
                                                  <td class="text-center sett-td">{{item.purchPrice}}</td>
                                                  <td class="text-center sett-td">{{item.wholePrice}}</td>
                                                  <td class="text-center sett-td">{{item.createDate | utc}}</td>
                                                  <td class="text-center sett-td">{{item.drugNum}}</td>
                                                  <td class="text-center sett-td">{{item.drugName}}</td>
                                                  <td class="text-center sett-td">{{item.factroy}}</td>
                                                  <td class="text-center sett-td">{{item.pack}}</td>
                                                  <td class="text-center sett-td">{{item.drugType}}</td>
                                                  <td class="text-center sett-td">{{item.drugUnit}}</td>
                                                  <td class="text-center sett-td">{{item.approvalNum}}</td>
                                                  <td class="text-center sett-td">{{item.states}}</td>
                                                  <td style="width:100px;text-align:center;" class="btn">
                                                    <template v-if="item.states == '已审核'">
                                                        <el-button type="primary" size="mini" @click="toPath(item)">上传</el-button>
                                                    </template>
                                                    <template v-else>
                                                        <span style="color:red;font-size:12px;">审核后可上传</span>
                                                    </template>
                                                  </td>
                                </tr>
                                </tbody>

                            </table>


                                        <!-- 分页 -->
                                               <div>
                                                 <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                                               </div>
                                           <p class="text-center">
                                                <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                                           </p>


                     </div>
                      <div v-else>

                       <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                     </div>



                    </div>


                        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content" style="width:1200px;position:relative;top:50px;left:-150px;">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                     <div class="card">
                                          <div class="card-header">
                                               <div class="font">
                                                   查询条件
                                               </div>
                                          </div>
                                          <div class="card-body">
                                               <div class="form-group d-flex">
                                                    <input type="text" class="form-control w-25" placeholder="供应商名称" v-model="searchForm.searchKey" @keydown.enter="searchEnterFun1">
                                                    <button class="ml-lg-2 btn btn-primary" @click="getSupplierQuery()">
                                                        搜索
                                                    </button>
                                               </div>
                                          </div>
                                          <div v-if="showChaxun">
                                                    <table class="table table-striped table-hover">
                                                        <thead>
                                                            <tr style="white-space: nowrap;">
                                                                <th>供应商名称</th>
                                                                <th>供应商代号</th>
                                                                <th>供应商类型</th>
                                                                <th>状态</th>
                                                                <th>操作</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <tr v-for="(item,index) in supplierList" :key="index">
                                                                 <td class="jz_middle">{{item.supplierName}}</td>
                                                                 <td class="jz_middle">{{item.supplierNum}}</td>
                                                                 <td class="jz_middle">{{item.supplierType}}</td>
                                                                 <td class="jz_middle">
                                                                    <span class="disabled_state">
                                                                       {{item.state}}
                                                                    </span>
                                                                  </td>
                                                                 <td class="jz_middle">
                                                                     <button class="btn btn-success" style="font-size:8px;" @click="getCode1(index)">
                                                                         选择
                                                                     </button>

                                                                 </td>
                                                             </tr>
                                                        </tbody>
                                                    </table>
                                                    <nav aria-label="Page navigation" style="text-align:center;" v-if="this.supplierList.length>0" class="mb-2">
                                                        <ul class="pagination">
                                                        <li class="page-item ml-5" :class="PageNo2<=1?'disabled':''" @click="prePage2()">
                                                            <a aria-label="Previous" class="page-link">
                                                            <span aria-hidden="true">&laquo;</span>
                                                            </a>
                                                        </li>
                                                            <li :class="index==PageNo2?'active':''" class="page-item" v-for="index of Pcount2" :key="index"
                                                                                                @click="curPage2(index)">
                                                                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                                                                <a class="page-link" v-if="index>20 && index==(Pcount2-1)">...</a>
                                                                                                <a class="page-link" v-if="index>20 && index==Pcount2">{{Pcount2}}</a>
                                                            </li>
                                                        <li class="page-item" :class="PageNo2>=Pcount2?'disabled':''" @click="nextPage2()">
                                                            <a aria-label="Next" class="page-link">
                                                            <span aria-hidden="true">&raquo;</span>
                                                            </a>
                                                        </li>
                                                        </ul>
                                                   </nav>
                                               </div>

                                                 <div v-if="showImage">

                                                     <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                                              </div>
                                     </div>
                               </div>
                            <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                                    <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" @click="getCode()"><span aria-hidden="true"></span>确定</button> -->
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="myModal_yao" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content" style="width:100%;position:relative;top:50px;left:-150px;min-width:1200px;">
                                <div class="modal-header">
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body">
                                     <div class="card">
                                          <div class="card-header">
                                               <div class="font">
                                                   查询条件
                                               </div>
                                          </div>
                                          <div class="card-body">
                                               <div class="form-group d-flex">
                                                    <input type="text" class="form-control w-25" placeholder="药品名称" v-model="searchForm.searchKey1" @keydown.enter="searchEnterFun2">
                                                    <input type="text" class="form-control w-25 ml-lg-2" placeholder="产地名称" v-model="searchForm.searchKey2" @keydown.enter="searchEnterFun2">
                                                    <input type="text" class="form-control w-25 ml-lg-2" placeholder="规格" v-model="searchForm.searchKey3" @keydown.enter="searchEnterFun2">
                                                    <button class="ml-lg-2 btn btn-primary" @click="getSupplierDrug()">
                                                        搜索
                                                    </button>
                                               </div>
                                                   <table class="table table-striped table-hover" v-if="drugList.length>0">
                                                        <thead>
                                                            <tr style="white-space: nowrap;">
                                                                <th>药品名称</th>
                                                                <th>药品编号</th>
                                                                <th>单位</th>
                                                                <th>生产厂家</th>
                                                                <th>包装中</th>
                                                                <th>包装</th>
                                                                <th>规格</th>
                                                                <th>税率</th>
                                                                <th>上市许可持有人</th>
                                                                <th>批准文号有限期</th>
                                                                <th>原产地</th>
                                                                <th>管控品种</th>
                                                                <th>首营资料</th>
                                                                <th>状态</th>
                                                                <th style="min-width:100px;">操作</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                             <tr v-for="(item,index) in drugList" :key="index">
                                                                 <td class="jz_middle">{{item.drugName}}</td>
                                                                 <td class="jz_middle">{{item.drugNum}}</td>
                                                                 <td class="jz_middle">{{item.drugUnit}}</td>
                                                                 <td class="jz_middle">{{item.factoryName}}</td>
                                                                 <td class="jz_middle">{{item.middlePack}}</td>
                                                                 <td class="jz_middle">{{item.pack}}</td>
                                                                 <td class="jz_middle">{{item.specification}}</td>
                                                                 <td class="jz_middle">{{item.defaultTaxRate}}</td>
                                                                 <td class="jz_middle">{{item.ownerName}}</td>
                                                                 <td class="jz_middle">
                                                                    <span style="color:red;font-size:15px;">
                                                                        {{item.approvalDueDate | formatUTC}}
                                                                    </span>
                                                                  </td>
                                                                 <td class="jz_middle">{{item.prodAddress}}</td>
                                                                 <td class="jz_middle" style="color:red;">{{item.gkpz==0?"":"管控品种"}}</td>
                                                                 <td class="jz_middle" :class="{'yanse':item.syzl==0,'yanse1':item.syzl!==0}">{{item.syzl==0?"无首营资料":"有首营"}}</td>
                                                                 <td class="jz_middle" :class="{'yanse':item.state!=='','yanse1':item.state==''}">{{item.state==""?"正常":"禁用"}}</td>
                                                                 <td class="jz_middle">
                                                                    <button class="btn btn-success" @click="getCode2(index)" style="font-size:8px;">选择</button>
                                                                 </td>
                                                             </tr>
                                                        </tbody>

                                                    </table>
                                                     <nav aria-label="Page navigation" style="text-align:center;" v-if="this.drugList.length>0" class="mb-2">
                                                        <ul class="pagination">
                                                        <li class="page-item ml-5" :class="PageNo1<=1?'disabled':''" @click="prePage1()">
                                                            <a aria-label="Previous" class="page-link">
                                                            <span aria-hidden="true">&laquo;</span>
                                                            </a>
                                                        </li>
                                                            <li :class="index==PageNo1?'active':''" class="page-item" v-for="index of Pcount1" :key="index"
                                                                                                @click="curPage1(index)">
                                                                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                                                                <a class="page-link" v-if="index>20 && index==(Pcount1-1)">...</a>
                                                                                                <a class="page-link" v-if="index>20 && index==Pcount1">{{Pcount1}}</a>
                                                            </li>
                                                        <li class="page-item" :class="PageNo1>=Pcount1?'disabled':''" @click="nextPage1()">
                                                            <a aria-label="Next" class="page-link">
                                                            <span aria-hidden="true">&raquo;</span>
                                                            </a>
                                                        </li>
                                                        </ul>
                                                   </nav>
                                          </div>
                                     </div>
                               </div>
                               <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal"><span aria-hidden="true"></span>关闭</button>
                                    <!-- <button type="button" class="btn btn-primary" data-dismiss="modal"><span aria-hidden="true"></span>确定</button> -->
                               </div>
                            </div>
                        </div>
                    </div>





                    <div v-show="showChuang" class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
                              <div class="card-header text-center" style="background-color:#3190e8;color:#fff;font-size:15px;">
                                   创建报计划
                              </div>
                              <table class="font table_chuang">
                                   <tr>
                                        <td class="text-center">
                                             <span>
                                                  供应商名称:
                                             </span>
                                        </td>
                                        <td>
                                             <input type="text" name="txt_departmentname" class="input_form-control" id="txt_departmentname" placeholder="供应商名称" v-model="creation.supplierName" disabled="disabled">
                                             <input type="text" placeholder="供应商编号" class="d-none" v-model="creation.supplierNum">
                                        </td>
                                        <td>
                                           <button class="btn btn-primary float-left font_btn mb-2 mr-2" id="btn_add" @click="change1()">
                                             查询
                                           </button>
                                        </td>
                                   </tr>
                                   <tr>
                                        <td class="text-center">
                                            <span>
                                                药品名称:
                                            </span>
                                        </td>
                                        <td>
                                              <input type="text" name="txt_parentdepartment" class="input_form-control" id="txt_parentdepartment" placeholder="药品名称" v-model="creation.drugName" disabled="disabled">
                                        <input type="text" placeholder="药品编号" class="d-none" v-model="creation.drugNum">
                                        </td>
                                        <td>
                                            <button class="btn btn-primary float-left font_btn mb-2 mr-2" id="btn_yao" @click="change2()">
                                            查询
                                            </button>
                                        </td>
                                   </tr>
                                   <tr>
                                        <td class="text-center">
                                            <span>
                                                 进价:
                                            </span>
                                        </td>
                                        <td>
                                              <input type="text" name="txt_statu" class="input_form-control" id="txt_statu" placeholder="进价" v-model="creation.purchPrice">
                                        </td>
                                   </tr>
                                   <tr>
                                        <td class="text-center">
                                            <span>
                                                 批量价:
                                            </span>
                                        </td>
                                        <td>
                                           <input type="text" name="txt_statu" class="input_form-control" id="txt_statu" placeholder="批量价" v-model="creation.wholePrice">
                                        </td>
                                   </tr>
                                    <tr>
                                        <td class="text-center">
                                            <span>
                                                 采购数量:
                                            </span>
                                        </td>
                                        <td>
                                            <input type="text" name="txt_statu" class="input_form-control" id="txt_statu" placeholder="采购数量" v-model="creation.goodsNum">
                                        </td>
                                   </tr>
                                   <tr>
                                         <td colspan="3" class="text-center">
                                              <button type="button" id="btn_submit" class="btn btn-primary font_btn" data-dismiss="modal" @click="create()"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span>创建</button>
                                         </td>
                                   </tr>

                              </table>

                    </div>
                </div>
                  <div>
                  <transition name="fade">
                           <loading v-if="isLoading"></loading>
                  </transition>
                </div>

     </div>
</template>
<script>
 import vPagination from "../components/Pagination.vue"
import date from '../components/Date.vue'
import date3 from '../components/Date3.vue'
import Loading from '../components/Loading.vue'
export default {
      data(){
          return {
            Height:0,
             showChuang:false,
              showPage:true,
           searchForm: {
           supplierNum:'',
           drugNameOrCode:'',
         searchKey1:'',
         searchKey2:'',
         searchKey3:'',
          DateMoreThan: '',
          DateLessThan: '' ,
          DateLessThan1: '',
          DateMoreThan1: '',
          DateLessThan_getOrder:'',
        },//搜索内容
        //创建内容
        creation:{
            supplierName:'',
            supplierNum:'',
            drugNum:'',
            drugName:'',
            approvalNum:'',
            clerkNum:'',
            creater:'',
            purchPrice:'',
            wholePrice:'',
            goodsNum:'',


        },
              tableData:[],
                Record: '',//总记录数
                Pcount: '',//总页数
                PageNo: 1 ,//当前页码
                    total:1,     // 记录总条数
                    display: 20,   // 每页显示条数
                    current: 1,   // 当前的页数
                Record1:'',
                Pcount1:'',
                PageNo1:1,
                Record2:'',
                Pcount2:'',
                PageNo2:1,
                isLoading: false,
                supplierList:[],
                drugList:[],


            showChaxun:false,
            showImage:false,
          }
      },
      components:{
          // mheader,
          date,
          // mfooter,
          vPagination,
          Loading,
          date3,
      },
        filters: {
      formatUTC:function(utc_datetime) {
        // 转为正常的时间格式 年-月-日 时:分:秒
           let time=utc_datetime.replace(/T/ig,"  ").substring(0,10)
           let cuttime1=new Date(time).getTime()
           let cuttime2=new Date().getTime()+24*60*60*1000
           if(cuttime1<cuttime2){
             return "批准文号已过期"
           }


        } ,
        utc:function(utc_datetime){
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        },
         changeDate(date){
           let change_date=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
           return change_date+" 00:00:00"
      },
      changeDate1(date){
         let time_change=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
        let year=new Date(new Date(time_change).getTime()-24*60*60*1000).getFullYear();

        let month=new Date(new Date(time_change).getTime()-24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(time_change).getTime()-24*60*60*1000).getDate();

        let time;
             if(month<10){
                      if(time_date<10)
                       time=year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=year+"-"+month+"-"+time_date;
                     }
                  }

         let change_date=time;
           return change_date+" 23:59:59"
      }
       },
      methods:{
          searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
            this.Search();
         }
      },

      toPath(item) {
        let obj = {
            ypmc: item.drugName,
            cdmc: item.factroy,
            gg: item.specification,
            orderno:item.num
        }
        window.sessionStorage.setItem('upImgObj', JSON.stringify(obj))
        this.$router.push(`/uploadImage?ypbh=${item.drugNum}`)
      },

        searchEnterFun1(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.getSupplierQuery();
         }
      },
      searchEnterFun2(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.getSupplierDrug();
         }
      },
        //获得编号
        getCode2:function(index){
            // this.creation.drugName=this.drugList[index].drugName;
            // this.creation.approvalNum=this.drugList[index].approvalNum;
            let time=this.drugList[index].approvalDueDate.replace(/T/ig,"  ").substring(0,10)
           let cuttime1=new Date(time).getTime()
           let cuttime2=new Date().getTime()
          //  if(this.drugList[index].syzl==0){
          //      alert("此药品无首营资料,请重新选择")
          //  }
          //  else if(this.drugList[index].state!==''){
          //      alert("此药品已禁用，请重新选择")
          //  }
           if(this.drugList[index].gkpz!=0){
               alert("1.供货单位必须上传监管码 2.管控品种发票要有批号产地")
               this.getSupplierCheckDrug(index);
           }
           else if(this.drugList[index].zbpz==1){
             alert("该品种为集采品种，需上传监管码")
             this.getSupplierCheckDrug(index);
           }
           else{
             this.getSupplierCheckDrug(index);
             }

        },
        getCode1:function(index){
            //  this.supplierList.forEach(element => {
            //      console.log(element.supplierNum)
            //  });
            // this.creation.supplierName=this.supplierList[index].supplierName;
            // this.creation.supplierNum=this.supplierList[index].supplierNum;
            this.getSupplierCheckSupplier(index);

        },
            //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
          this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
          // console.log(time)
          this.searchForm.DateMoreThan1=date;
      },
          //单击改变宽度
           changeWidth:function(e){
               if(e.target.className.indexOf("add_autocut")>-1){

                   $(e.target).removeClass("add_autocut")
               }else{
                   $(e.target).addClass("add_autocut")
               }
      },

          //搜索供应商
          getSupplierQuery:async function(PageIndex){

             this.PageNo2 = PageIndex || this.PageNo2
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierQuery',
                obj: JSON.stringify({
                PageIndex,
                searchKey:this.searchForm.searchKey,
              })
             }
               )
              //  console.log(res)
                if (res.isok) {
                    const obj = res.data
                    this.supplierList = obj.rows
                  if(this.supplierList.length>0)
                {
                    this.showChaxun=true;
                    this.showImage=false;
                }
                else{
                    this.showChaxun =false;
                    this.showImage=true;
                }
                    this.Pcount2 = obj.pcount
                    this.Record2 = obj.record
               }
          },
          //搜索药品
          getSupplierDrug:async function(PageIndex){
                 this.PageNo1 = PageIndex || this.PageNo1
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierDrug',
                obj: JSON.stringify({
                PageIndex,
                searchKey1:this.searchForm.searchKey1,
                searchKey2:this.searchForm.searchKey2,
                searchKey3:this.searchForm.searchKey3,
              })
             }
               )
              //  console.log(res)
                if (res.isok) {
                    const obj = res.data
                    this.drugList = obj.rows
                     this.Pcount1 = obj.pcount
                    this.Record1 = obj.record

               }
          },
          //检查代理商
          getSupplierCheckClerk:async function(){
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierCheckClerk',
                obj: JSON.stringify({
                  clerkNum:window.sessionStorage.getItem("username"),//代理商号
              })
             }
               )
              //  console.log(res)
                if (res.data.result.isSucceed) {
               }
                else{
                  alert("你没有权限")
                }
          },
          //检查供应商
         getSupplierCheckSupplier:async function(index){
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierCheckSupplier',
                obj: JSON.stringify({
                  supplierNum:this.supplierList[index].supplierNum,//供应商编号
              })
             }
               )
              //  console.log(res)
                if (res.data.result.isSucceed) {
                       if(res.data.result.msg==""){
                         alert("选择成功")
                         $('#myModal').modal('hide');
                        this.creation.supplierName=this.supplierList[index].supplierName;
                        this.creation.supplierNum=this.supplierList[index].supplierNum;
                       }
                       else{
                            alert(res.data.result.msg)
                         $('#myModal').modal('hide');
                        this.creation.supplierName=this.supplierList[index].supplierName;
                        this.creation.supplierNum=this.supplierList[index].supplierNum;
                       }
               }
               else{
                  alert(res.data.result.msg)

               }
          },
          //检查药品
          getSupplierCheckDrug:async function(index){
              const that=this
               const {data:res} = await that.$http.post('Dls/getFun',
               {
                action: 'SupplierCheckDrug',
                obj: JSON.stringify({
                  supplierNum:that.creation.supplierNum,//供应商编号
                  drugNum:that.drugList[index].drugNum, //药品编号
              })
             }
               )
              //  console.log(res)
              if (res.data.result.isSucceed) {
                  if(res.data.result.msg ==""){
                      alert("选择成功")
                    $('#myModal_yao').modal('hide');
                  that.creation.drugName=that.drugList[index].drugName;
                  that.creation.drugNum=that.drugList[index].drugNum;

                  }
                  else{
                     alert(res.data.result.msg)
                      $('#myModal_yao').modal('hide');
                      that.creation.drugName=that.drugList[index].drugName;
                      that.creation.drugNum=that.drugList[index].drugNum;
                  }
               }
               else{
                 alert(res.data.result.msg)
               }
          },
          // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
             getDay1(day) {　
              //  console.log(day)　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                // 　                console.log(today)　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　
                // console.log(tYear +""+ tMonth +""+ tDate)　
                return tYear +''+ tMonth +''+ tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
        getSupplierOrder: async function (PageIndex) {
              //获取三个月前的时间戳   时间条件适合才可以查询
        const that = this
        let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();

        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{


        if((threeMonthTime<=seTime&&seTime<=todayTime) && (threeMonthTime<=seTime2&&seTime2<=todayTime)){

        this.isLoading=true;

        if(!PageIndex){PageIndex=1}
        that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'SupplierOrder',
          obj: JSON.stringify({
            PageIndex,
            supplierNum:that.searchForm.supplierNum,
            drugNameOrCode:that.searchForm.drugNameOrCode,
            createDateStart: that.searchForm.DateLessThan,  // 销售日期不小于
            createDateEnd: that.searchForm.DateMoreThan, // 销售日期不大于
          })
        })

        //  console.log(res)
        if(res.isok){
              const obj = res.data
               that.tableData = obj.rows
                  if(this.tableData.length>0)
                        {
                            this.showPage=true;
                        }
                        else{
                            this.showPage =false;
                        }
                  that.Pcount = obj.pcount
                  that.Record = obj.record
                  that.total = obj.record
                that.showChuang = true;
                that.isLoading=false;

        }


          }
          else{
            alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          }



        }

      },
      //创建报计划
       create:async function(){
         if(this.creation.supplierName==""||this.creation.drugNum==""||this.creation.purchPrice==""||this.creation.wholePrice==""||this.creation.goodsNum==""){
           alert("创建内容填写不完整,请填写完整信息")
         }else{
            const that=this
               const {data:res} = await that.$http.post("/Dls/getFun",
               {
                action: 'CreateSupplierPurchOrder',
                obj: JSON.stringify({
                   supplierNum:this.creation.supplierNum,
                   drugNum:this.creation.drugNum,
                   clerkNum:window.sessionStorage.getItem("username"),
                   creater:this.creation.creater,
                   purchPrice:this.creation.purchPrice,
                   wholePrice:this.creation.wholePrice,
                   goodsNum:this.creation.goodsNum,
              })
             }
               )
              //  console.log(res)
              if(res.data.result.isSucceed){
                   if(res.data.result.msg == ""){
                      this.creation.supplierName="";
                        this.creation.drugNum="";
                        this.creation.clerkNum="";
                        this.creation.creater="";
                        this.creation.purchPrice="";
                        this.creation.wholePrice="";
                        this.creation.goodsNum="";
                   }
                   else{
                     alert(res.data.result.msg)
                           this.creation.supplierName="";
                           this.creation.drugNum="";
                           this.creation.clerkNum="";
                           this.creation.creater="";
                           this.creation.purchPrice="";
                           this.creation.wholePrice="";
                           this.creation.goodsNum="";
                   }
              }else{
                  alert(res.data.result.msg)
              }
         }

       },

       pagechange:function(currentPage){

           this.getSupplierOrder(currentPage);

     },

       curPage1: function (index) {

        //  if(this.searchData.length>0){
        //     this.Search(index)
        //  }
        //  else{
           this.getSupplierDrug(index)
        //  }
      },
      //上一页
      prePage1: function () {
        if (this.PageNo1 > 1) {
          this.PageNo1--;
          //  if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{

            this.getSupplierDrug(this.PageNo1);
          // }
        }
      },
      //下一页
      nextPage1: function () {
        if (this.PageNo1 < this.Pcount1) {
          this.PageNo1++;
          // if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{
            this.getSupplierDrug(this.PageNo1);
          // }
        }
      },
      //当前页
       curPage2: function (index) {

        //  if(this.searchData.length>0){
        //     this.Search(index)
        //  }
        //  else{
           this.getSupplierQuery(index)
        //  }
      },
      //上一页
      prePage2: function () {
        if (this.PageNo2 > 1) {
          this.PageNo2--;
          //  if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{

            this.getSupplierQuery(this.PageNo2);
          // }
        }
      },
      //下一页
      nextPage2: function () {
        if (this.PageNo2 < this.Pcount2) {
          this.PageNo2++;
          // if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{
            this.getSupplierQuery(this.PageNo2);
          // }
        }
      },
        change1(){
               $("#myModalLabel").text("查询");
               $('#myModal').modal();
        },
        change2(){
             if(!this.creation.supplierName){
                  alert("请先选择供应商名称")
                }else{
                  $("#yaoping").text("查询");
                  $('#myModal_yao').modal();
                }
        }
      },
      mounted(){

      },
    mounted(){
    this.Height = document.documentElement.clientHeight - 100;
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}

    },
      created(){
        this.getSupplierCheckClerk()
          this.searchForm.DateMoreThan=this.getDay1(1)
          this.searchForm.DateLessThan=this.getDay1(-7)
          this.searchForm.DateLessThan1=this.getDay(-8)
          this.searchForm.DateMoreThan1=this.getDay(0)
          this.getSupplierOrder()
      }
}
</script>
<style scoped>
    .hei{
        height:1.5rem;
    }
     .font_btn{
         font-size:10px!important;
     }
     .jz_title{
          vertical-align: middle;
     }
     .sou_container{
         position:absolute;
         flex-wrap: wrap;
         top:35%;
         left:50%;
         transform: translateX(-50%) translateY(-50%);
     }
   .input_sou{
       width:300px;
       height:35px;
       font-size:20px;
   }
   .font_sou{
       font-size:20px;
   }
   .button_sou{
      height:35px;
   }
   .font{
    font-size:15px;
  }
  .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
 .sett{
        width:1300px;
        table-layout:fixed;

  }
  .sett-td {

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

   -moz-text-overflow: ellipsis;

}

/deep/ .btn .el-button--mini {
    padding: 4px 8px;
}

.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
 .autocut:hover
 {
     overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .add_autocut{
    overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .hei{
     height:1.5rem;
 }
 .alert_show{
    position:absolute;
    top:81px;
    left:450px;
 }
 .yanse{
   color:red;
 }
 .yanse1{
   color:green;
 }
 .disabled_state{
   color:red;
   font-size:15px;
   /* border:.1px solid red; */
 }
 .jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .input_form-control {
/* // display: block;  */
width: 50%;
height: 34px;
padding: 6px 12px;
font-size: 14px;
line-height: 1.428571429;
color: #555555;
vertical-align: middle;
background-color: #ffffff;
border: 1px solid #cccccc;
border-radius: 4px;
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.input_form-control:focus {
border-color: #66afe9;
outline: 0;
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
.table_chuang{
  width:1000px;
  height:400px;
  margin:0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Plan.vue